import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import makeStyles from "@material-ui/core/styles/makeStyles";
import CardTitle from "@saleor/components/CardTitle";
import SingleSelectField from "@saleor/components/SingleSelectField";
import { sectionNames } from "@saleor/intl";
import React from "react";
import { useIntl } from "react-intl";

export interface CategoryStoreType {
  data: {
    storeType?: string;
  };
  disabled: boolean;
  id: string;
  onChange: (event: React.ChangeEvent<any>) => void;
}

const useStyles = makeStyles(
  theme => ({
    content: {
      paddingTop: theme.spacing(2)
    },
    hr: {
      margin: theme.spacing(2, 0)
    },
    select: {
      margin: theme.spacing(2, 0)
    }
  }),
  {
    name: "ProductStatus"
  }
);

const CategoryStoreType: React.FC<CategoryStoreType> = ({
  data: { storeType },
  disabled,
  id,
  onChange
}) => {
  const intl = useIntl();
  const classes = useStyles({});

  const storeTypes = [
    { label: "Food and Beverages", value: "FOOD_AND_BEVERAGES" },
    { label: "General Merchandise", value: "GENERAL_MERCHANDISE" },
    { label: "Grocery", value: "GROCERY" }
  ];
  return (
    <Card>
      <CardTitle title={intl.formatMessage(sectionNames.categoryStoreType)} />
      <CardContent className={classes.content}>
        <SingleSelectField
          label={intl.formatMessage({
            defaultMessage: "Store Type"
          })}
          disabled={disabled || id ? true : false}
          onChange={onChange}
          choices={storeTypes}
          name="storeType"
          value={storeType}
        />
      </CardContent>
    </Card>
  );
};

CategoryStoreType.displayName = "CategoryStoreType";
export default CategoryStoreType;
